import elementClosestPolyfill from "element-closest"
elementClosestPolyfill(window)

import './plugins/giant.cloner'